import * as React from "react";
import SelectComponent from "../ui/select/SelectComponent";
import Account from "../../model/account/Account";
import {option} from "ts-option";

export default class SelectAccount extends SelectComponent<Account> {
	matchFilter(element: Account, filter: string): boolean {
		return element.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: Account): string {
		return element.code;
	}

	elementToString(element: Account) {
		return element.name;
	}

	getDropdownList() {
		return option(this.props.items.getOrElse([]).filter(a => a.availableForUser));
	}
}
